"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVAILABLE_LOCALES = void 0;
exports.AVAILABLE_LOCALES = [
    'en_US',
    'es_ES',
    'id_ID',
    'it_IT',
    'nl_NL',
    'fr_FR',
    'pt_BR',
    'ru_RU',
    'pl_PL',
    'ro_RO',
    'de_DE',
    'nb_NO',
    'sv_SE',
    'fi_FI',
    'uk_UA',
    'el_GR',
    'da_DK',
    'cs_CZ',
    'hu_HU',
    'tr_TR',
    'ar_SA',
    'vi_VN',
    'th_TH',
    'ko_KR',
    'ja_JP',
];
